import { motion } from 'framer-motion';

import EnableReporting from './EnableReporting';
import WhyCreditBuilder from './WhyCreditBuilder';
import CreditScore from './CreditScore';
import FAQsSectionCreditHealth from './FAQSectionCreditHealth';
import { useEffect, useState } from 'react';
import { FAQResponse } from '../../helpers/utils/types';
import { getFAQs, HIDE_CREDIT_HEALTH } from '../../auth/_requests';
import { useAuth } from '../../auth/Auth';
import CreditHealthScore from '../dashboard/CreditHealthScore/CreditHealthScore';

const CreditHealth = () => {
  const { auth } = useAuth();
  const [creditHealthFaqs, setCreditHealthFaqs] = useState<FAQResponse[]>([]);

  useEffect(() => {
    const getCreditBuilderFAQs = async () => {
      try {
        const response = await getFAQs(auth?.data?.token, 'creditBuilder');
        if (response) {
          setCreditHealthFaqs(response);
        } else {
          setCreditHealthFaqs([]);
        }
      } catch (error) {
        console.error('Error fetching referral FAQs:', error);
      }
    };
    getCreditBuilderFAQs();
  }, []);
  return (
    <motion.section
      initial={{ opacity: 0, y: -5 }} // Starts slightly above
      animate={{ opacity: 1, y: 0 }} // Slides down to position
      transition={{ duration: 0.4, ease: 'easeOut' }}
    >
      <div className='flex flex-col xxl:flex-row gap-5 w-full'>
        {/* Left Column */}
        <div className='flex-[6] w-full p-12 flex flex-col gap-16'>
          <EnableReporting />
          <WhyCreditBuilder />

          {/* FAQs visible only on xxl and above inside first column */}

          <div className='hidden xxl:block'>
            <FAQsSectionCreditHealth faqs={creditHealthFaqs} />
          </div>
        </div>

        {/* Right Column */}
        {!HIDE_CREDIT_HEALTH && (
          <div className='flex-[4] p-12 '>
            <div className='flex flex-col gap-10 w-full'>
              {!HIDE_CREDIT_HEALTH && <CreditHealthScore />}
              <CreditScore />
            </div>
          </div>
        )}

        {/* FAQs visible only below entire layout for small screens */}
        <div className='block xxl:hidden p-12'>
          <FAQsSectionCreditHealth faqs={creditHealthFaqs} />
        </div>
      </div>
    </motion.section>
  );
};

export default CreditHealth;
